<!--ptw总包与分包分类-->
<template>
  <!--<div v-if="dataNotNull" key="1" class="ptwclassifyDiv" style="width: 100%; height: 100%">-->
  <div class="container1" style="margin:15px 0 0 10px; height: 100%;width: 100%">
    <div style="font-size:16px;margin: 10px 0px 20px 25px;text-align: left;font-weight:bold;color:white">Progress</div>
    <!--<el-progress type="circle" :text-inside="true" :stroke-width="20" :percentage="50" status="exception" text-inside="true"></el-progress>-->
    <!--<div style="margin-left:35px; >-->
    <el-progress type="circle" :percentage="86" color="#FF8040" :width="135" :stroke-width="12"></el-progress>
    <!--</div>-->
  </div>

  <!--</div>-->
  <!--<div v-else key="2" style="width: 100%; height: 100%;">-->
  <!--<div class="title_ptw">Permit-to-Work (PTW) Type</div>-->
  <!--<div class="zero_ptw">No Data !</div>-->
  <!--</div>-->
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id'],
  name: "ptwclassifys",
  data() {
    return {
      my_project_id: this.project_id,
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "ptwclassifys",
      dataNotNull: true
    }
  }
}
</script>


<style lang="stylus" rel="stylesheet/stylus">
.title_ptw
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.zero_ptw
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>




// WEBPACK FOOTER //
// src/components/quality/ptwclassify.vue